module.exports = __webpack_public_path__ + "img/filter.37f0d869.svg";